// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".xy" + {"364":"bfee982a4ba17d3b8883","396":"a1f85239d9eb04c5f489","476":"bd9aa8372ad8d2652945"}[chunkId] + ".js";
};